import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Mail = () => {
    return (
        <div className='mail'>
            <div className='max-width'>
                <div className='mhead'>Feel free to contact us</div>
                <Container>
                    <Row>
                        <Col>
                            <div className='maCard'>
                                <div className='maH'>
                                    <div className='maCircle'>
                                        <img src='Call.png' alt='' />
                                    </div>
                                    <h1>Call us</h1>
                                </div>
                                <h2>+91 9311898085</h2>
                            </div>
                        </Col>

                        <Col>
                            <div className='maCard'>
                                <div className='maH'>
                                    <div className='maCircle'>
                                        <img src='Mail.png' alt='' />
                                    </div>
                                    <h1>Mail us</h1>
                                </div>
                                <h2>udelineindia@gmail.com</h2>
                            </div>
                        </Col>

                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default Mail;